import React from "react";
//#region types
import { CurrencyCode } from "models/enums/currency";
import { VoucherFormTypes } from "models/formTypes";
import { Amount } from "models/utilTypes/currencyType";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { TableAsync } from "components/common";
import { useFormikContext } from "formik";
//#endregion

const AccountBalances: React.FC = () => {
  const { values } = useFormikContext<VoucherFormTypes.Create>();

  const getRows = () => {
    const newValues = [...(values.accountItems ?? []).filter((ai) => ai.accountId)];

    newValues.forEach((v) => {
      const balanceAccount = values.accountBalances?.find((b) => b.accountId === v.accountId);
      v.balanceBefore = balanceAccount?.balanceBefore;
      v.balanceAfter = (v.balanceBefore ?? 0) + (v.amount ?? 0);
    });

    return newValues;
  };

  return (
    <TableAsync<VoucherFormTypes.AccountItem>
      properties={{
        accountName: {
          description: TranslationKeys.Common.Account,
          isTextSmall: true,
          width: "35%",
        },
        balanceBefore: {
          description: TranslationKeys.Voucher.BalanceBefore,
          alignment: "right",
          formatter: (val: VoucherFormTypes.AccountItem) => new Amount(CurrencyCode.SEK, val.balanceBefore),
          classification: "amount",
        },
        amount: {
          description: TranslationKeys.Voucher.Change,
          alignment: "right",
          formatter: (val: VoucherFormTypes.AccountItem) => new Amount(CurrencyCode.SEK, val.amount),
        },
        balanceAfter: {
          description: TranslationKeys.Voucher.BalanceAfter,
          alignment: "right",
          formatter: (val: VoucherFormTypes.AccountItem) => new Amount(CurrencyCode.SEK, val.balanceAfter),
          classification: "amount",
        },
      }}
      filter={getRows()}
      pagination={false}
      disableSort={true}
    />
  );
};

export default AccountBalances;
